import { render, staticRenderFns } from "./car-flag.vue?vue&type=template&id=5ad60a28&scoped=true&"
import script from "./car-flag.vue?vue&type=script&lang=js&"
export * from "./car-flag.vue?vue&type=script&lang=js&"
import style0 from "./car-flag.vue?vue&type=style&index=0&id=5ad60a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad60a28",
  null
  
)

export default component.exports